var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.727 6.31308L3.707 2.29308L2.293 3.70708L20.293 21.7071L21.707 20.2931L19.687 18.2731C21.1861 16.5276 22.0068 14.3009 21.999 12.0001C21.999 7.90908 19.527 4.54708 16 3.00008V5.00008C18.387 6.38608 19.999 9.04708 19.999 12.0001C19.9939 13.7767 19.4069 15.5027 18.328 16.9141L17.042 15.6281C17.644 14.5361 18 13.1901 18 12.0001C18 10.2291 17.225 8.10008 16 7.00008V14.5861L14 12.5861V2.13208L7.727 6.31308ZM4 17.0001H6.697L14 21.8681V18.1211L3.102 7.22308C2.77189 7.38832 2.4941 7.64191 2.29954 7.95564C2.10499 8.26937 2.00129 8.63092 2 9.00008V15.0001C2 16.1031 2.897 17.0001 4 17.0001Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume_mute.1caa7b45.svg";
export { ForwardRef as ReactComponent };